// import bootstrap files
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import { lazy, Suspense, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import EatsureKnowMore from './components/IdleScreen/EatsureKnowMore';
import store, { persistConfig } from './store';
import ErrorWrapper from './components/ErrorWrapper/ErrorWrapper';
import idb from './helpers/indexedDB';

idb.bootstrap();
const persistor = persistStore(store,persistConfig);
const HomePage = lazy(() => import('./components/HomePage/HomePage'));
const OrderDetails = lazy(() => import('./components/Orders/OrderDetails'));
const InternetLostScan = lazy(() =>
	import('./components/InternetConnection/InternetConnectionLostScan')
);
const IdlePage = lazy(() => import('./components/IdleScreen/IdleScreen'));
const FTSComponent = lazy(() =>
	import('./components/FirstTimeSetUpComponent/FirstTimeSetUpComponent')
)
;

export default function App() {
	useEffect(() => {
		return () => {};
	}, []);
	const [kioskStoreId, setkioskStoreId] = useState();
	const [deviceId, setDeviceId] = useState();
	useEffect(() => {
		console.log(deviceId);
		if(deviceId)
		{
			//used for KIOSK EDC ID
			idb.setItemSync('kiosk_device_id',deviceId);
		}
		
	}, [deviceId]);

	return (
		<>
			{/* <Online> */}
			<Suspense fallback={''}>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						{/* render router or complete app block here */}
						<Router>
							<ErrorWrapper>
							<Routes>
									<Route
										path='/'
										element={
											<FTSComponent
												setkioskStoreId={setkioskStoreId}
												kioskStoreId={kioskStoreId}
											/>
									}>
									<Route
										index
										element={<IdlePage setDeviceId={setDeviceId}></IdlePage>}
									/>

									<Route
										path='/Home'
										element={
											<HomePage
												kioskStoreId={kioskStoreId}></HomePage>
										}
									/>
									<Route
										path='InternetLostScan'
										element={<InternetLostScan></InternetLostScan>}
									/>
									<Route
										path='order-detail/:crn'
										element={<OrderDetails></OrderDetails>}
									/>
								</Route>
								<Route
									path='/eatsure-know-more'
									element={<EatsureKnowMore></EatsureKnowMore>}
								/>
							</Routes>
							</ErrorWrapper>
						</Router>
					</PersistGate>
				</Provider>
			</Suspense>
			{/* </Online>
			<Offline> */}
			{/* <Router>
				<InternetConnection />
			</Router> */}
			{/* </Offline> */}
		</>
	);
}
